exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.5@core-js/library/modules/_wks-ext.js
// module id = 163
// module chunks = 0